import React, { useState } from "react";
import moment from "moment";
import TopInfoBox from "../../app/routes/lodgeaCall2/topInfoBox";
import { Button } from "@material-ui/core";

const SuspendedFranchiseeInfo = ({
  suspendedFranchisee,
  fromContinueMessageOperator,
  stage,
  messageSubmit,
  setMessageSubmit,
  onUserConfirm,
}) => {
  const [showMessageForm, setShowMessageForm] = useState(false);
  const [isExistingCustomer, setIsExistingCustomer] = useState(null);

  if (suspendedFranchisee.leadSuspend !== "1") return null;

  const {
    name,
    memberName,
    suspendByRange,
    leadSuspendStartDate,
    leadSuspendEndDate,
    leadSuspendReasonID,
    leadSuspendReason,
    callCenterNotification,
  } = suspendedFranchisee;

  const formattedStart = leadSuspendStartDate
    ? moment(leadSuspendStartDate).format("dddd, Do MMMM YYYY")
    : "";
  const formattedEnd = leadSuspendEndDate
    ? moment(leadSuspendEndDate).format("dddd, Do MMMM YYYY")
    : "";

  const suspendedName = name || memberName;

  const suspensionReason = leadSuspendReasonID || leadSuspendReason;

  const suspensionPeriod =
    suspendByRange === "0" && formattedStart && formattedEnd
      ? ` from ${formattedStart} to ${formattedEnd}`
      : "";

  const message = `${callCenterNotification}${suspensionPeriod}`;

  // If coming from ContinueMessageOperator and user hasn't made a choice yet
  if (fromContinueMessageOperator && isExistingCustomer === null) {
    return (
      <div>
        <TopInfoBox text={message} warningText="" variant="suspension" />
        <TopInfoBox text="Are you an existing customer?" />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginTop: "10px",
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              setIsExistingCustomer(true);
              setShowMessageForm(true);
              onUserConfirm && onUserConfirm(true, true);
            }}
            style={{
              minWidth: "100px",
              border: "2px solid #3f51b5",
            }}
          >
            Yes
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => {
              setIsExistingCustomer(false);
              setShowMessageForm(true);
              onUserConfirm && onUserConfirm(true, false);
            }}
            style={{
              minWidth: "100px",
              border: "2px solid #f50057",
            }}
          >
            No
          </Button>
        </div>
      </div>
    );
  }

  // If coming from ContinueMessageOperator and user has made a choice
  return (
    <div>
      <TopInfoBox text={message} warningText="" variant="suspension" />

      {fromContinueMessageOperator && isExistingCustomer === null && (
        <>
          <TopInfoBox text="Are you an existing customer?" />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              marginTop: "10px",
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setIsExistingCustomer(true);
                setShowMessageForm(true);
                onUserConfirm && onUserConfirm(true, true);
              }}
              style={{ minWidth: "100px" }}
            >
              Yes
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                setIsExistingCustomer(false);
                setShowMessageForm(true);
                onUserConfirm && onUserConfirm(true, false);
              }}
              style={{ minWidth: "100px" }}
            >
              No
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default SuspendedFranchiseeInfo;
